import { render } from "./ModalAddRepresentanteFatca.vue?vue&type=template&id=28719e90"
import script from "./ModalAddRepresentanteFatca.vue?vue&type=script&lang=js"
export * from "./ModalAddRepresentanteFatca.vue?vue&type=script&lang=js"

import "./ModalAddRepresentanteFatca.vue?vue&type=style&index=0&id=28719e90&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__